template = require('./pie_chart.html.slim')

angular.module('wbComponents').directive 'wbPieChart',
[ ->
  scope:
    data: '='
    value: '@'
  restrict: 'E'
  replace: true
  transclude: true
  templateUrl: template
]
